/** A disabled action keeps its name, with the reason as tooltip and accessible description. */
export function needsServer(offline: boolean): { title?: string; 'aria-description'?: string } {
  return offline ? { title: 'Needs the server', 'aria-description': 'Needs the server' } : {}
}
